import 'bootstrap/dist/css/bootstrap.min.css';
import './Useless/ComplexTable'
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ComplexTableExample from './Useless/ComplexTable';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import NavigationBar from './NavigationBar';
import Manage_buyer from './Manage Data/manage_buyer';
import Manage_team from './Manage Data/manage_team';
import Manage_party from './Manage Data/manage_party';
import ManageItem from './Manage Data/manage_item';
import ManageSpecification from './Manage Data/manage_specification';
import ManageUnits from './Manage Data/manage_units';
import ManageGrade from './Manage Data/manage_grade';
import Manage_gsm from './Manage Data/manage_gsm';
import Additional_work from './Manage Data/additional_work';
import ManageBrand from './Manage Data/manage_brand';
import ManageDepartment from './Manage Data/manage_department';
import ManagePartyBank from './Manage Data/manage_party_bank';
import ManageCompanyBank from './Manage Data/manage_company_bank';
// import ComplexTableExample from './Useless/ComplexTable';
import Add_new_order from './Functions/add_new_order';
import Add_new_party from './Manage Data/add_new_party';
import Demo_Table from './Useless/Demo_Table';
import ManageOrders from './Functions/manage_orders';
import PerfectTable from './Functions/perfect_table';
import ProductionPlanning from './Functions/production_planning';
import BoardMaking from './Functions/board_making';
import ManageFinishing from './Functions/manage_finishing';
import ManageDelivery from './Functions/manage_delivery';
import ManageDeliveryChallan from './Functions/delivery_challan';
import ManageGatePass from './Functions/manage_gate_pass';
import BMHistory from './Functions/BM_history';
import FinishingHistory from './Functions/finishing_history';
import NewDeliveryChallan from './Functions/new_delivery_challan';
import ChangeDeliveryChallan from './Functions/change_delivery_challan';
import NewGatePass from './Functions/new_gate_pass';
import CreateBill from './Bill/create_bill';
import BillList from './Bill/bill_list';
import ProformaInvoice from './Commercial/proforma_invoice';
import GroupPI from './Commercial/group_pi';
import CommercialTracking from './Commercial/commercial_tracking';
import PendingCommercial from './Commercial/pending_commercial';
import NewGroupPi from './Commercial/new_group_pi';
import Commercial from './Commercial/commercial';
import UpConsumption from './Commercial/up_consumption';
import DetailsReport from './Reports/details_report';
import LoginPage from './LoginPage';
import RequireAuth from './RequireAuth';
import ManageJobApproval from './Functions/manage_job_approval';
import ManageJobScheduling from './Functions/manage_job_scheduling';
import ChallanPDF from './PDFs/ChallanPDF';
import GatePassPDF from './PDFs/GatePassPDF';
import PiPDF from './PDFs/PiPDF';
import GroupPiPDF from './PDFs/GroupPiPDF';
import WorkOrderPDF from './PDFs/WorkOrderPDF';
import OrderSummary from './Reports/order_summary';
import DeliveryReport from './Reports/delivery_report';
import PartyHealth from './Reports/party_health';
import CommercialPDF from './PDFs/CommercialPDF';
// import BillPDF from './PDFs/BillPDF';
import React, { useEffect, useState, createContext, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AutoLogoutWrapper from './AutoLogoutWrapper';
import { Toaster } from './notify';
import ManageUsers from './Manage Users/ManageUsers';
import McpAccess from './Manage Users/McpAccess';
import AlertRules from './Manage Users/AlertRules';
import AIOfficeApp from './AIOffice/AIOfficeApp';
import FlowtechAI from './FlowtechAI/FlowtechAI';
import BillPDF from './PDFs/BillPDF2';
import RollReceipts from './Stock/roll_receipts';
import PaperStockSummary from './Stock/paper_stock_summary';
import RollCodes from './Stock/roll_codes';
import PaperBalance from './Stock/paper_balance';
import BoardPlan from './Functions/board_plan';
import PaperConsumption from './Reports/paper_consumption';
import GenericTemplatePDF from './PDFs/GenericTemplatePDF';
import CanvasEditor from './TemplateBuilder/CanvasEditor';
import SavedCommercialViewer from './PDFs/ComponentsOfCommercialPDF/SavedCommercialViewer';
import ForwardingLetterPDF from './PDFs/ForwardingLetterPDF';
import PurchaseOrderPDF from './PDFs/PurchaseOrderPDF';
import SavedDocumentViewer from './PDFs/SavedDocumentViewer';
import PurchaseBoard from './Purchase/PurchaseBoard';
import PurchaseFile from './Purchase/PurchaseFile';
import PurchaseVendors from './Purchase/Vendors';
import IndirectMaterials from './Purchase/IndirectMaterials';
import PurchaseSettings from './Purchase/PurchaseSettings';
import PurchaseStock from './Purchase/PurchaseStock';
import PurchaseWaiting from './Purchase/PurchaseWaiting';
import PurchaseLCRegister from './Purchase/PurchaseLCRegister';

// The Asma look (theme.css) is on everywhere except the PDF / print pages, which must print exactly as designed.
const PLAIN_PAGES = /(pdf-viewer|forwarding-letter|purchase-order-print|ai-office)/;
function ThemeScope() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        document.body.classList.toggle('ft-theme', !PLAIN_PAGES.test(pathname));
        document.body.classList.toggle('ft-login', pathname === '/');
    }, [pathname]);
    return null;
}

// "homepage":"http://flowtech.aligroupbd.net/",
// window.backendUrl = 'http://localhost:3005'
// REACT_APP_BACKEND_URL is set only by the local try-out script; the live build uses the live server.
window.backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://flowtechserver.aligroupbd.net'

// git add .
// git commit -m "A commit"
// git push -u origin main



function App() {
    const [showModal, setShowModal] = useState(false);
    const [passcode, setPasscode] = useState('');

    useEffect(() => {
        const keysPressed = new Set();

        const handleKeyDown = (e) => {
            // FIX: Check if e.key exists before using it
            if (!e.key) return;

            keysPressed.add(e.key.toLowerCase());
            if (keysPressed.has('s') && keysPressed.has('n') && keysPressed.has('i')) {
            setShowModal(true);
            }
        };

        const handleKeyUp = (e) => {
            // FIX: Check if e.key exists before using it
            if (!e.key) return;

            keysPressed.delete(e.key.toLowerCase());
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    useEffect(() => {
      const handleEmergencyKeys = async (e) => {
        // SEQUENCE 1: KILL (Ctrl + Alt + K)
        if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          try {
            await fetch(`${window.backendUrl}/api/emergency-kill`, { method: 'POST' });
            // alert("⚠️ CONNECTION LOST"); // Fake alert to make it look real
            window.location.reload(); // Reloads page to force errors to appear immediately
          } catch (err) {
            console.error(err);
          }
        }

        // SEQUENCE 2: REVIVE (Ctrl + Alt + O)
        if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'o') {
          e.preventDefault();
          try {
            await fetch(`${window.backendUrl}/api/emergency-revive`, { method: 'POST' });
            // alert("✅ Connection Restored");
            window.location.reload();
          } catch (err) {
            console.error(err);
          }
        }
      };

      window.addEventListener('keydown', handleEmergencyKeys);
      return () => window.removeEventListener('keydown', handleEmergencyKeys);
    }, []);
    

    const handlePasscodeSubmit = () => {
        if (passcode === 'procholo'){
            localStorage.setItem('company', 'Propack Trims & Accessories Industries');
            window.dispatchEvent(new Event('localStorageChange'));
        }
        window.location.reload();
        setShowModal(false);
        setPasscode('');
    };
    
    return (
        <>
        <BrowserRouter>
        <ThemeScope />
        <AutoLogoutWrapper>
            <Routes>
                <Route path='/' element={<LoginPage/>} />
                <Route element={<RequireAuth/>}>
                    <Route path="manage-orders" element={<ManageOrders/>} />
                    <Route path="/work-order-pdf-viewer/:orderId" element={<WorkOrderPDF />} />
                    <Route path="manage-job-approval" element={<ManageJobApproval/>} />
                    <Route path="manage-job-scheduling" element={<ManageJobScheduling/>} />
                    <Route path="production-planning" element={<ProductionPlanning/>} />
                    <Route path="board-making" element={<BoardMaking/>} />
                    <Route path='board-making-history' element={<BMHistory/>}/>
                    <Route path='manage-finishing' element={<ManageFinishing/>} />
                    <Route path='finishing-history' element={<FinishingHistory/>} />
                    <Route path='manage-delivery' element={<ManageDelivery/>} />
                    <Route path='manage-delivery-challan' element={<ManageDeliveryChallan/>} />
                    <Route path="/challan-pdf-viewer/:challanId" element={<ChallanPDF />} />
                    <Route path='new-delivery-challan' element={<NewDeliveryChallan/>} />
                    <Route path='change-delivery-challan' element={<ChangeDeliveryChallan/>} />
                    <Route path='manage-gate-pass' element={<ManageGatePass/>} />
                    <Route path="/gatePass-pdf-viewer/:gatePassId" element={<GatePassPDF />} />
                    <Route path='new-gate-pass' element={<NewGatePass/>} />
                    <Route path='roll-purchase' element={<RollReceipts/>} />
                    <Route path='stock-summary' element={<PaperStockSummary/>} />
                     <Route path='roll-codes' element={<RollCodes/>} />
                    <Route path='paper-balance' element={<PaperBalance/>} />
                    <Route path='board-plan' element={<BoardPlan/>} />
                    <Route path='paper-consumption' element={<PaperConsumption/>} />
                    <Route path="create-bill" element={<CreateBill/>} />
                    <Route path="bill-list" element={<BillList/>} />
                    <Route path="/bill-pdf-viewer/:billId" element={<BillPDF/>} />
                    <Route path="/bill-saved-pdf-viewer/:billId" element={<SavedDocumentViewer docType="bill" />} />
                    <Route path="proforma-invoice" element={<ProformaInvoice/>} />
                    <Route path="/pi-pdf-viewer/:piId" element={<PiPDF/>} />
                    <Route path="/pi-saved-pdf-viewer/:piId" element={<SavedDocumentViewer docType="pi" />} />
                    <Route path="/group-pi-pdf-viewer/:groupPiId" element={<GroupPiPDF/>} />
                    <Route path="/group-pi-saved-pdf-viewer/:groupPiId" element={<SavedDocumentViewer docType="groupPi" />} />
                    <Route path="commercial-list" element={<Commercial/>} />
                    <Route path="/commercial-pdf-viewer/:commercialId" element={<CommercialPDF/>} />
                    <Route path="/commercial-saved-pdf-viewer/:commercialId" element={<SavedCommercialViewer />} />
                    <Route path="/forwarding-letter/:commercialId" element={<ForwardingLetterPDF />} />
                    <Route path="/purchase-order-print/:id" element={<PurchaseOrderPDF />} />
                    <Route path="/commercial-tracking" element={<CommercialTracking/>} />
                    <Route path="/pending-commercial" element={<PendingCommercial/>} />
                    <Route path="group-pi" element={<GroupPI/>} />
                    <Route path="new-group-pi" element={<NewGroupPi/>} />
                    <Route path="up-consumption" element={<UpConsumption/>} />
                    <Route path="add-new-order" element={<Add_new_order/>} />
                    <Route path="perfect-table" element={<PerfectTable />} />
                    <Route path="demo-table" element={<Demo_Table/>} />
                    <Route path="add-new-party" element={<Add_new_party />} />
                    <Route path="manage-party" element={<Manage_party />} />
                    <Route path="manage-buyer" element={<Manage_buyer />} />
                    <Route path="manage-team" element={<Manage_team />} />
                    <Route path="manage-item" element={<ManageItem />} />
                    <Route path="manage-specification" element={<ManageSpecification />} />
                    <Route path="manage-units" element={<ManageUnits />} />
                    <Route path="manage-grade" element={<ManageGrade />} />
                    <Route path="manage-gsm" element={<Manage_gsm/>} />
                    <Route path="additional-work" element={<Additional_work />} />
                    <Route path="manage-brand" element={<ManageBrand />} />
                    <Route path="manage-department" element={<ManageDepartment />} />
                    <Route path="manage-party-bank" element={<ManagePartyBank />} />
                    <Route path="manage-company-bank" element={<ManageCompanyBank />} />
                    <Route path="details-report" element={<DetailsReport />} />
                    <Route path="order-summary-report" element={<OrderSummary />} />
                    <Route path="delivery-report" element={<DeliveryReport />} />
                    <Route path="party-health" element={<PartyHealth />} />
                    <Route path="manage-users" element={<ManageUsers/>} />
                    <Route path="mcp-access" element={<McpAccess/>} />
                    <Route path="alert-rules" element={<AlertRules/>} />
                    {/* AI Office opens in its own window and renders without the NavigationBar */}
                    <Route path="ai-office" element={<AIOfficeApp/>} />
                    <Route path="flowtech-ai" element={<FlowtechAI/>} />
                    <Route path="template-builder" element={<CanvasEditor />} />
                    <Route path="purchase-board" element={<PurchaseBoard/>} />
                    <Route path="/purchase-file/:id" element={<PurchaseFile/>} />
                    <Route path="purchase-vendors" element={<PurchaseVendors/>} />
                    <Route path="purchase-materials" element={<IndirectMaterials/>} />
                    <Route path="purchase-settings" element={<PurchaseSettings/>} />
                    <Route path="purchase-stock" element={<PurchaseStock/>} />
                    <Route path="purchase-waiting" element={<PurchaseWaiting/>} />
                    <Route path="purchase-lc-register" element={<PurchaseLCRegister/>} />
                    {/* <Route path="template-builder/:templateId?" element={<CanvasEditor />} />
                    <Route path="/template-pdf-viewer/:templateId" element={<GenericTemplatePDF />} /> */}
                </Route>
            </Routes>
        </AutoLogoutWrapper>
        </BrowserRouter>
        <Toaster />
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Passcode</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="password"
                        value={passcode}
                        onChange={(e) => setPasscode(e.target.value)}
                        className="form-control"
                        name="password"
                        autoComplete='new-password'
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handlePasscodeSubmit}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default App;